import { TableProps, Table as AntTable } from "antd";
import { AnyObject } from "antd/es/_util/type";
import { twMerge } from "tailwind-merge";

export function Table<T extends AnyObject>(props: TableProps<T>) {
  const { className, ...rest } = props;

  return (
    <div className="overflow-auto">
      <AntTable<T>
        className={twMerge(
          "[&_.ant-table-cell]:whitespace-nowrap [&_.ant-table-title]:!p-0",
          className,
        )}
        {...rest}
      />
    </div>
  );
}
